export const HOST_API = process.env.REACT_APP_API_ENDPOINT || 'https://api.workingfeedback.cloud';